// import i18n from '../../plugins/i18n';
import { validatedRules } from '../../plugins/validatedRules';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';

export function getMLB9IDefaultConfig() {
  return cloneDeep(defaultMLB9IConfig);
}

export function getMLB9ICurrentConfig(taskConfig) {
  const config = getMLB9IDefaultConfig();
  if (isEmpty(taskConfig) || Object.keys(taskConfig).length === 0) {
    return config;
  }
  for (const key in config) {
    if (key in taskConfig) {
      config[key].currentValue = taskConfig[key];
      config[key].value = taskConfig[key];
    }
  }
  return config;
}

const defaultMLB9IConfig = {
  isRunPlayLeagueGame: {
    currentValue: true,
    value: true,
    type: 'bool',
    basic: true,
    title: {
      en: 'Play League Game',
      zhHant: '打聯賽',
      ja: 'リーグ戦をする',
      ko: '리그 게임하기',
    },
    help: {
      en: 'Play in league games?',
      zhHant: '是否打聯賽',
      ja: 'リーグ戦に参加しますか？',
      ko: '리그 게임에 참여하시겠습니까?',
    },
  },
  leaguePlaySpeed: {
    parent: 'isRunPlayLeagueGame',
    currentValue: 'auto',
    value: 'auto',
    rules: [validatedRules.required],
    type: 'selection',
    options: [
      { value: 'auto', text: { en: 'Auto (Smart)', zhHant: '自動（智慧）', ja: 'オート（スマート）', ko: '자동(스마트)' } },
      { value: 'slow', text: { en: 'Slow', zhHant: '慢速', ja: '低速', ko: '저속' } },
      { value: 'fast', text: { en: 'Fast', zhHant: '快速', ja: '高速', ko: '고속' } },
    ],
    basic: true,
    clearable: false,
    title: {
      en: 'League Play Speed',
      zhHant: '聯賽速度',
      ja: 'リーグ戦速度',
      ko: '리그 게임 속도',
    },
    help: {
      en: 'Set the game play speed for league games. Auto mode (Recommended): Smart speed adjustment - fast for 10+ balls, slow for 9 or fewer balls to maximize resources.',
      zhHant: '設定聯賽遊戲速度。自動模式（建議）：智慧調整速度 - 10球以上快速刷，9球以下慢速刷，可獲得較多資源。',
      ja: 'リーグ戦のゲーム速度を設定します。オートモード（推奨）：スマート速度調整 - 10球以上は高速、9球以下は低速で、より多くのリソースを獲得できます。',
      ko: '리그 게임의 플레이 속도를 설정합니다. 자동 모드(권장): 스마트 속도 조절 - 10개 이상의 볼은 빠르게, 9개 이하의 볼은 천천히 진행하여 더 많은 자원을 획득할 수 있습니다.',
    },
  },
  leagueMode: {
    parent: 'isRunPlayLeagueGame',
    currentValue: 'master',
    value: 'master',
    rules: [validatedRules.required],
    type: 'selection',
    options: [
      { value: 'normal', text: { en: 'Normal', zhHant: '一般', ja: 'ノーマル', ko: '일반' } },
      { value: 'master', text: { en: 'Master', zhHant: '大師', ja: 'マスター', ko: '마스터' } },
    ],
    basic: true,
    clearable: false,
    title: {
      en: 'League Mode',
      zhHant: '聯賽模式',
      ja: 'リーグモード',
      ko: '리그 모드',
    },
    help: {
      en: 'League Mode',
      zhHant: '聯盟年度',
      ja: 'リーグモード',
      ko: '리그 모드',
    },
  },
  leagueYear: {
    parent: 'isRunPlayLeagueGame',
    currentValue: 2024,
    value: 2024,
    min: 2024,
    max: 2038,
    rules: [validatedRules.required, validatedRules.numberInMinMax],
    type: 'number',
    basic: true,
    clearable: false,
    title: {
      en: 'League Year',
      zhHant: '聯盟年度',
      ja: 'リーグ年度',
      ko: '리그 연도',
    },
    help: {
      en: 'League Year',
      zhHant: '聯盟年度',
      ja: 'リーグ年度',
      ko: '리그 연도',
    },
  },
  leagueSeasonMode: {
    parent: 'isRunPlayLeagueGame',
    currentValue: 'full',
    value: 'full',
    type: 'selection',
    options: [
      { value: 'full', text: { en: 'Full', zhHant: '完整', ja: 'フル', ko: '전체' } },
      { value: 'half', text: { en: 'Half', zhHant: '半', ja: 'ハーフ', ko: '반' } },
      { value: 'quarter', text: { en: 'Quarter', zhHant: '四分之一', ja: 'クォーター', ko: '쿼터' } },
      { value: 'postSeason', text: { en: 'Post Season', zhHant: '季後賽', ja: 'ポストシーズン', ko: '포스트 시즌' } },
    ],
    rules: [validatedRules.required],
    basic: true,
    clearable: false,
    title: {
      en: 'League Season Mode',
      zhHant: '聯盟賽季模式',
      ja: 'リーグシーズンモード',
      ko: '리그 시즌 모드',
    },
    help: {
      en: 'League Season Mode',
      zhHant: '聯盟賽季模式',
      ja: 'リーグシーズンモード',
      ko: '리그 시즌 모드',
    },
  },
  leagueIsUseDrink: {
    parent: 'isRunPlayLeagueGame',
    currentValue: false,
    value: false,
    type: 'bool',
    basic: true,
    title: {
      en: 'Use Energy Drink in League',
      zhHant: '聯賽時使用能量飲料',
      ja: 'リーグ戦でエナジードリンクを使用する',
      ko: '리그에서 에너지 드링크 사용',
    },
    help: {
      en: 'Automatically use energy drinks during league games?',
      zhHant: '是否在聯賽時自動使用能量飲料？',
      ja: 'リーグ戦中にエナジードリンクを自動的に使用しますか？',
      ko: '리그 게임 중에 에너지 드링크를 자동으로 사용하시겠습니까?',
    },
  },
  // leagueIsUseGear: {
  //   parent: 'isRunPlayLeagueGame',
  //   currentValue: false,
  //   value: false,
  //   type: 'bool',
  //   basic: true,
  //   title: {
  //     en: 'Use Gear in League',
  //     zhHant: '聯賽時使用裝備',
  //     ja: 'リーグ戦でギアを使用する',
  //     ko: '리그에서 장비 사용',
  //   },
  //   help: {
  //     en: 'Automatically use gear during league games? (Platinum gear will not be used)',
  //     zhHant: '是否在聯賽時自動使用裝備？（不使用白金裝備）',
  //     ja: 'リーグ戦中にギアを自動的に使用しますか？（プラチナギアは使用しません）',
  //     ko: '리그 게임 중에 장비를 자동으로 사용하시겠습니까? (플래티넘 장비는 사용하지 않음)',
  //   },
  // },
  leagueIsUseDoublePTicket: {
    parent: 'isRunPlayLeagueGame',
    currentValue: false,
    value: false,
    type: 'bool',
    basic: true,
    title: {
      en: 'Use P-Coin Multiplier Ticket',
      zhHant: '使用P幣加倍券',
      ja: 'Pコインマルチプライヤーチケットを使用する',
      ko: 'P코인 배율 티켓 사용',
    },
    help: {
      en: 'Automatically use P-coin multiplier tickets during league games?',
      zhHant: '是否在聯賽時自動使用P幣加倍券？',
      ja: 'リーグ戦中にPコインマルチプライヤーチケットを自動的に使用しますか？',
      ko: '리그 게임 중에 P코인 배율 티켓을 자동으로 사용하시겠습니까?',
    },
  },
  leagueIsBuyEnergy: {
    parent: 'isRunPlayLeagueGame',
    currentValue: false,
    value: false,
    type: 'bool',
    basic: true,
    title: {
      en: 'Use Recharge Ticket in League',
      zhHant: '聯賽時使用球補充劵',
      ja: 'リーグ戦でボール補充券を使用する',
      ko: '리그에서 볼 보충권 사용',
    },
    help: {
      en: 'Automatically use recharge tickets to refill balls during league games?',
      zhHant: '是否在聯賽時自動使用球補充劵來補充球數？',
      ja: 'リーグ戦中にボール補充券を自動的に使用してボールを補充しますか？',
      ko: '리그 게임 중에 볼 보충권을 자동으로 사용하여 볼을 보충하시겠습니까?',
    },
  },
  isRunPlayBattleGame: {
    currentValue: true,
    value: true,
    type: 'bool',
    basic: true,
    title: {
      en: 'Play Ranked Battle',
      zhHant: '打排名戰',
      ja: 'ランク戦をする',
      ko: '랭크 전투하기',
    },
    help: {
      en: 'Play in ranked battles?',
      zhHant: '是否打排名戰',
      ja: 'ランク戦に参加しますか？',
      ko: '랭크 전투에 참여하시겠습니까?',
    },
  },
  rankBattleIsUseDrink: {
    parent: 'isRunPlayBattleGame',
    currentValue: false,
    value: false,
    type: 'bool',
    basic: true,
    title: {
      en: 'Use Energy Drink in Ranked Battle',
      zhHant: '排名戰時使用能量飲料',
      ja: 'ランク戦でエナジードリンクを使用する',
      ko: '랭크 전투에서 에너지 드링크 사용',
    },
    help: {
      en: 'Automatically use energy drinks during ranked battles?',
      zhHant: '是否在排名戰時自動使用能量飲料？',
      ja: 'ランク戦中にエナジードリンクを自動的に使用しますか？',
      ko: '랭크 전투 중에 에너지 드링크를 자동으로 사용하시겠습니까?',
    },
  },
  rankBattleIsBuyEnergy: {
    parent: 'isRunPlayBattleGame',
    currentValue: false,
    value: false,
    type: 'bool',
    basic: true,
    title: {
      en: 'Use Recharge Ticket in Ranked Battle',
      zhHant: '排名戰時使用球補充劵',
      ja: 'ランク戦でボール補充券を使用する',
      ko: '랭크 전투에서 볼 보충권 사용',
    },
    help: {
      en: 'Automatically use recharge tickets to refill balls during ranked battles?',
      zhHant: '是否在排名戰時自動使用球補充劵來補充球數？',
      ja: 'ランク戦中にボール補充券を自動的に使用してボールを補充しますか？',
      ko: '랭크 전투 중에 볼 보충권을 자동으로 사용하여 볼을 보충하시겠습니까?',
    },
  },
  // rankBattleIsUseGear: {
  //   parent: 'isRunPlayBattleGame',
  //   currentValue: false,
  //   value: false,
  //   type: 'bool',
  //   basic: true,
  //   title: {
  //     en: 'Use Gear in Ranked Battle',
  //     zhHant: '排名戰時使用裝備',
  //     ja: 'ランク戦でギアを使用する',
  //     ko: '랭크 전투에서 장비 사용',
  //   },
  //   help: {
  //     en: 'Automatically use gear during ranked battles? (Platinum gear will not be used)',
  //     zhHant: '是否在排名戰時自動使用裝備？（不使用白金裝備）',
  //     ja: 'ランク戦中にギアを自動的に使用しますか？（プラチナギアは使用しません）',
  //     ko: '랭크 전투 중에 장비를 자동으로 사용하시겠습니까? (플래티넘 장비는 사용하지 않음)',
  //   },
  // },
  isRunAdReward: {
    currentValue: false,
    value: false,
    type: 'bool',
    basic: true,
    title: {
      en: 'Auto Watch Ads',
      zhHant: '自動看廣告',
      ja: '広告を自動的に視聴',
      ko: '자동으로 광고 보기',
    },
    help: {
      en: 'Watch ads for rewards?',
      zhHant: '是否觀看廣告取得廣告獎勵',
      ja: '報酬のために広告を視聴しますか？',
      ko: '보상을 위해 광고를 보시겠습니까?',
    },
  },
  isRunDailyMission: {
    currentValue: false,
    value: false,
    type: 'bool',
    basic: true,
    title: {
      en: 'Run Daily Mission',
      zhHant: '執行每日任務',
      ja: '日課をこなす',
      ko: '매일 임무를 수행하다',
    },
    help: {
      en: 'Automatically perform weekly missions?',
      zhHant: '是否自動執行每週任務？',
      ja: '毎日のタスクを自動で実行しますか？',
      ko: '매일 작업을 자동으로 실행하시겠습니까?',
    },
  },

};
